import { Side } from '../../../utils/enum';

export const CARD_DIMENSIONS = {
  height: 2.125,
  width: 3.37,
};

export type PictureState = {
  [Side.Front]: Blob | null;
  [Side.Back]: Blob | null;
};

export type CaptureType = 'camera' | 'upload';

export type UploadError =
  | null
  | 'incorrect_filetype'
  | 'pdf_conversion_failure';
